export const formatMoney = () => {
    const formatter = new Intl.NumberFormat("en-US", {});
    return formatter;
};
